export default __webpack_public_path__ + "static/pritchie-1b9e9bf5cae7b1d02fcca15ad26b9b57.png";